import { createAction, createSlice } from '@reduxjs/toolkit';

import { resetStateAction } from '!core/redux';

const initialState = {
  topGroups: { data: [], selected: '', isLoadingInstrTopGroups: false },
  data: [],
  isLoadingInstruments: false,
};

const logoutSuccessAction = createAction('logoutSlice/logoutSuccess');

const clearState = () => ({ ...initialState });

export const trlTopInstrumentsSlice = createSlice({
  name: 'trlTopInstrumentsSlice',
  initialState,
  reducers: {
    instrumentsTopGroupsRequest: (state) => {
      state.topGroups.isLoadingInstrTopGroups = true;
    },
    instrumentsTopGroupsSucess: (state, { payload }) => {
      state.topGroups.data = payload;
      state.topGroups.isLoadingInstrTopGroups = false;
    },
    instrumentsTopGroupsFailure: (state) => {
      state.topGroups.isLoadingInstrTopGroups = false;
    },
    selectInstrTopGroup: (state, { payload }) => {
      state.topGroups.selected = payload.instrumentTopGroup;
    },
    topInstrumentsRequest: (state) => {
      state.isLoadingInstruments = true;
    },
    topInstrumentsSucess: (state, action) => {
      state.data = action.payload;
      state.isLoadingInstruments = false;
    },
    topInstrumentsFailure: (state) => {
      state.isLoadingInstruments = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logoutSuccessAction, clearState)
      .addCase(resetStateAction, clearState);
  },
});
